export const MSG = {
  LOGIN_FAIL: "IDまたはパスワードが違います",
};
